import React from "react";
import { Sale } from "@/models/sale";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

interface SalesTableProps {
  data: Array<{
    sellerId: string;
    sellerName: string;
    sellerEmail?: string | null; // Campo opcional soportado
    totalAmount: number;
    salesCount: number;
  }>;
}

// Función para extraer el nombre de usuario del correo electrónico
const extractNameFromEmail = (email: string | null): string => {
  if (!email) return "Desconocido";
  
  // Extraer la parte antes del @ en el correo
  const nameMatch = email.match(/^([^@]+)@/);
  if (nameMatch && nameMatch[1]) {
    // Capitalizar la primera letra
    return nameMatch[1].charAt(0).toUpperCase() + nameMatch[1].slice(1);
  }
  
  return "Desconocido";
};

// Si el nombre es "Desconocido", muestra el email si existe, si no muestra "Desconocido"
export const SalesTable: React.FC<SalesTableProps> = ({ data }) => {
  // Encontrar el monto máximo para calcular los porcentajes
  const maxAmount = Math.max(...data.map(seller => seller.totalAmount));

  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Vendedor</TableHead>
            <TableHead>Correo del Vendedor</TableHead>
            <TableHead className="text-right">Ventas</TableHead>
            <TableHead className="text-right">Total</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {data.map((seller) => {
            // Calcular el porcentaje relativo al máximo
            const percentage = (seller.totalAmount / maxAmount) * 100;
            
            return (
              <TableRow key={seller.sellerId}>
                <TableCell>
                  <div className="space-y-2">
                    <div className="text-foreground">{seller.sellerName}</div>
                    <div className="relative w-full h-6 bg-muted rounded-lg overflow-hidden">
                      <div 
                        className="absolute left-0 top-0 h-full bg-warning transition-all duration-500 ease-in-out"
                        style={{ width: `${percentage}%` }}
                      />
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  {seller.sellerEmail && seller.sellerEmail !== ""
                    ? seller.sellerEmail
                    : "Sin correo registrado"}
                </TableCell>
                <TableCell className="text-right">{seller.salesCount}</TableCell>
                <TableCell className="text-right">
                  {new Intl.NumberFormat('es-AR', {
                    style: 'currency',
                    currency: 'ARS'
                  }).format(seller.totalAmount)}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};
